import React, { useState } from 'react';
import { View, useWindowDimensions } from 'react-native';
import AgentsPriceCard from './AgentsPricingCard';
import { LeadCaptureDialog } from '../LeadCaptureDialog';

const plans = [
  {
    tag: 'Standard', title: 'For a single user/agent',
    priceMonthly: '£500', priceAnnual: '£400', ctaVariant: 'primary',
    rows: [['Agent one-time setup', '£1,000'], ['Output Tokens', '20 USD per million'], ['Input Tokens', '3 USD per million'], ['Query Usage', 'DWH Standard Cost'], ['Support', 'Email']],
  },
  {
    tag: 'Enterprise', featured: true, title: 'For scale (Per 5 users/agents)',
    priceMonthly: '£2,000', priceAnnual: '£1,400', ctaVariant: 'secondary',
    rows: [['Agent one-time setup', '£3,000'], ['Output Tokens', '20 USD per million'], ['Input Tokens', '3 USD per million'], ['Query Usage', 'DWH Standard Cost'], ['Support', 'Dedicated Slack + SLA']],
  },
];

export default function AgentsPricingCards({ period, submitHandler, responseStatus, onGetStarted }) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { width } = useWindowDimensions();
  const isCompact = width < 700;

  return (
    <View
      style={{
        flexDirection: isCompact ? 'column' : 'row',
        gap: isCompact ? 20 : 28,
        paddingVertical: isCompact ? 32 : 44,
        paddingHorizontal: isCompact ? 20 : 48,
        maxWidth: 920,
        width: '100%',
        alignSelf: 'center',
      }}
    >
      {plans.map((plan) => (
        <AgentsPriceCard key={plan.tag} plan={plan} period={period} setDialogOpen={setDialogOpen} isCompact={isCompact} />
      ))}
      <LeadCaptureDialog visible={dialogOpen} onClose={() => setDialogOpen(false)} onSubmit={submitHandler} responseStatus={responseStatus} />
    </View>
  );
}
